import { render, staticRenderFns } from "./ExchangeRateList.vue?vue&type=template&id=5f50e494&scoped=true"
import script from "./ExchangeRateList.vue?vue&type=script&lang=js"
export * from "./ExchangeRateList.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRateList.vue?vue&type=style&index=0&id=5f50e494&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50e494",
  null
  
)

export default component.exports